/**
 * When used as /g[i] returns all the mention pattern from a string.
 * ex: '@[Yoann Jaspar](user:35) test @[Not Yoann Jaspar](user:36)'.match(MENTION_MARKUP)
 * [
 *  '@[Yoann Jaspar](user:35)',
 *  '@[Not Yoann Jaspar](user:36)'
 * ]
 *
 * When used as is, returns the content of the first mention markup found
 * ex: 'Test @[Yoann Jaspar](user:35)'.match(MENTION_MARKUP)
 * > [
 *     '@[Yoann Jaspar](user:35)',
 *     'Yoann Jaspar',
 *     '(user:35)',
 *     'user:35',
 *   ]
 */
export const MENTION_MARKUP = /@\[([^\]]+?)\](\(([^\)]+?)\))?/;

/**
 * Finds Mentions in a video comment or video comment reply.
 * Includes one capture group for the whole mention, and one
 * non-capturing group for an optional section.
 * ex:
 * 'Test @[Yoann Jaspar](user:35)'.match(MENTION_MARKUP_WHOLE)
 * > [
 *     '@[Yoann Jaspar](user:35)',
 *     '@[Yoann Jaspar](user:35)',
 *   ]
 */
export const MENTION_MARKUP_WHOLE = /(@\[[^\]]+?\](?:\([^\)]+?\))?)/;
